// import axios from 'axios'
// import React, { useEffect, useState } from 'react'

// const useGetTlAndEmp = () => {
//     const [alltloption, setAllTLOption] = useState([])
//     const [allempoption, setAllEmpOption] = useState([])

//     useEffect(() => {
//         try {
//             axios.get(process.env.REACT_APP_NEW_BASE_URL + '/getLeadsAndEmployees')
//                 .then((res) => {
//                     const leads = res?.data?.leads || [];
//                     const employees = res?.data?.employees || [];

//                     // Team Lead options
//                     if (Array.isArray(leads) && leads.length > 0) {
//                         const filterTLOption = leads.map((itm) => {
//                             return { value: itm.empId, label: itm.name }
//                         });
//                         setAllTLOption(filterTLOption);
//                     }

//                     // Remove leads from employee list
//                     if (Array.isArray(employees) && employees.length > 0) {
//                         const leadIds = leads.map((itm) => itm.empId);

//                         const filteredEmployees = employees.filter(
//                             (itm) => !leadIds.includes(itm.empId)
//                         );

//                         const filterEmpOption = filteredEmployees.map((itm) => {
//                             return { value: itm.empId, label: itm.name }
//                         });

//                         setAllEmpOption(filterEmpOption);
//                     }
//                 })
//                 .catch((err) => {
//                     console.log("Error", err)
//                 })
//         } catch (error) {
//             console.log("Error", error)
//         }
//     }, [])

//     return { alltloption, allempoption }
// }

// export default useGetTlAndEmp;

import axios from 'axios'
import React, { useEffect, useState } from 'react'

const useGetTlAndEmp = () => {
    const [alltloption, setAllTLOption] = useState([])
    const [allempoption, setAllEmpOption] = useState([])

    useEffect(() => {
        axios.get(process.env.REACT_APP_NEW_BASE_URL + '/getLeadsAndEmployees')
            .then((res) => {
                const leads = res?.data?.leads || [];
                const employees = res?.data?.employees || [];

                // ✅ TL options
                const filterTLOption = leads.map((itm) => ({
                    value: itm.empId,
                    label: itm.name
                }));
                setAllTLOption(filterTLOption);

                // ✅ Employee options (NO filtering here)
                const filterEmpOption = employees.map((itm) => ({
                    value: itm.empId,
                    label: itm.name
                }));
                setAllEmpOption(filterEmpOption);
            })
            .catch((err) => {
                console.log("Error", err)
            })
    }, [])

    return { alltloption, allempoption }
}

export default useGetTlAndEmp;
